import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {},
    lng: 'en',

    keySeparator: '..', // we do not use keys in form messages.welcome
    nsSeparator: '::',

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  })
  .then();

export default i18n;
